import React, { useEffect } from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { updateEditUserDetail } from "../../utils/reduxSlice/tempSlice";
import { endpoint } from "../../config";
import axios from "axios";

export default function PersonalLoanLayout() {
  // Hooks initialization
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get cookies and user data
  const appId = useSelector((state) => state.token.appId);
  const productType = useSelector((state) => state.token.productType);
  const user = useSelector((state) => state.user);

  // Edit states from Redux
  const editUserDetail = useSelector((state) => state.temp.editUserDetail);
  const glEditUserDetail = useSelector((state) => state.temp.glEditUserDetail);
  const hlEditUserDetail = useSelector((state) => state.temp.hlEditUserDetail);

  // Path and lender information
  const pathName = window.location.pathname;
  const isLender = !!localStorage.getItem("_lender");
  const isLenderType = process.env.REACT_APP_LENDER_TYPE;

  // Determine completion status based on product type
  const userCompleted =
    productType === "Gold Loans"
      ? user?.gl_completed
      : productType === "Business Loans"
        ? user?.bl_completed
        : productType === "Affordable Housing Loan"
          ? user?.hl_completed
          : user?.pl_completed;

  // Check if user details need updating (only for Personal Loans)
  const shouldUpdate =
    productType === "Personal Loans"
      ? user?.pl_update_required === 1 || user?.pl_se_update_required === 1
      : false;

  useEffect(() => {
    // Exit if user data is not available or invalid
    if (!user?.userId || Number.isNaN(userCompleted)) return;

    // Handle Lender Flow
    if (isLenderType && isLender) {
      if (pathName !== "/user/lender-submit" && userCompleted === 1) {
        navigate("/user/lender-submit", { replace: true });
        return;
      }
      if (pathName === "/user/lender-submit" && userCompleted !== 1) {
        navigate("/user/user-detail", { replace: true });
        return;
      }
    }

    // Handle Welcome Back Flow for existing profiles
    if (!appId && pathName !== "/user/welcome-back" && userCompleted === 1) {
      navigate("/user/welcome-back", { replace: true });
      return;
    }

    // Handle Personal Loan User Detail Status
    if (pathName === "/user/user-detail" && userCompleted !== 0 && !editUserDetail) {
      if (!shouldUpdate && productType === "Personal Loans") {
        navigate("/user/offers", { replace: true });
        return;
      }
      dispatch(updateEditUserDetail(true));
    }

    // Handle Gold Loan User Detail Status
    // if (pathName === "/user/user-detail/gold-loan" && userCompleted !== 0 && !glEditUserDetail) {
    //   axios.post(`${endpoint}/api/gold-loans/${appId}`).then(({ data }) => {
    //     navigate(`/user/${data.redirect}`, { replace: true });
    //   });
    //   return;
    // }

    // // Handle Housing Loan User Detail Status
    // if (pathName === "/user/user-detail/affordable-housing-loan" && userCompleted !== 0 && !hlEditUserDetail) {
    //   axios.post(`${endpoint}/api/housing-loan/${appId}`).then(({ data }) => {
    //     navigate(`/user/${data.redirect}`, { replace: true });
    //   });
    //   return;
    // }

    // Force user to fill user-detail based on loan type
    const isGoldLoanIncomplete =
      productType === "Gold Loans" &&
      pathName !== "/user/gold-loan-detail" &&
      userCompleted !== 1;

    const isHousingLoanIncomplete =
      productType === "Affordable Housing Loan" &&
      pathName !== "/user/affordable-housing-loan-detail" &&
      userCompleted !== 1;

    const isOtherLoanIncomplete =
      productType !== "Gold Loans" &&
      productType !== "Affordable Housing Loan" &&
      pathName !== "/user/user-detail" &&
      userCompleted !== 1;

    if (isGoldLoanIncomplete || isHousingLoanIncomplete || isOtherLoanIncomplete) {
      // Exception for completed Business Loans
      if (
        productType === "Business Loans" &&
        pathName.startsWith("/user/lenders-transaction") &&
        user.bl_completed === 1
      ) {
        return;
      }

      // Determine redirect path based on loan type
      const redirectPath =
        productType === "Gold Loans"
          ? "/user/gold-loan-detail"
          : productType === "Affordable Housing Loan"
            ? "/user/affordable-housing-loan-detail"
            : "/user/user-detail";

      navigate(redirectPath, { replace: true });
      return;
    }

    // Handle update required redirect
    if (pathName === "/user/offers" && shouldUpdate) {
      navigate("/user/user-detail", { replace: true });
      return;
    }

    // Final completion check for all loan types
    if (
      pathName === "/user/user-detail" &&
      userCompleted === 1 &&
      !shouldUpdate &&
      !editUserDetail
    ) {
      if (productType === "Personal Loans") {
        navigate("/user/offers", { replace: true });
      } else if (productType === "Gold Loans") {
        if (
          pathName === "/user/gold-loan-detail" &&
          !glEditUserDetail &&
          user.gl_completed === 1
        ) {
          axios.post(`${endpoint}/api/gold-loans/${appId}`).then(({ data }) => {
            navigate(`/user/${data.redirect}`, { replace: true });
          });
        }
      }
      // else if (productType === "Affordable Housing Loan") {
      //   if (
      //     pathName === "/user/user-detail/affordable-housing-loan" &&
      //     !hlEditUserDetail &&
      //     user.hl_completed === 1
      //   ) {
      //     axios.post(`${endpoint}/api/housing-loan/${appId}`).then(({ data }) => {
      //       navigate(`/user/${data.redirect}`, { replace: true });
      //     });
      //   }
      // }
    }
  }, [
    user?.userId,
    userCompleted,
    pathName,
    editUserDetail,
    glEditUserDetail,
    hlEditUserDetail,
    appId,
    productType,
    shouldUpdate,
    isLender,
    isLenderType,
    user?.bl_completed,
    user?.gl_completed,
    user?.hl_completed
  ]);

  // Final route validation
  if (
    productType !== "Personal Loans" &&
    productType !== "Gold Loans" &&
    productType !== "Affordable Housing Loan" &&
    productType === "Business Loans" &&
    !pathName.startsWith("/user/lenders-transaction")
  ) {
    return <Navigate to="/products" />;
  }

  return <Outlet />;
}